import { createSelector } from "reselect";
import { StoreState } from "Store/Reducers";

const getAllVacancyFromState = ({ vacancies }: any): any[] => vacancies?.saved;
export const getAllVacancy = createSelector(getAllVacancyFromState, (getAllVacancyFromState) => getAllVacancyFromState);

const getAllVacancyMetaFromState = ({ vacancies }: any): any[] => vacancies?.meta;
export const getAllVacancyMeta = createSelector(getAllVacancyMetaFromState, (getAllVacancyMetaFromState) => getAllVacancyMetaFromState);

const getVacancyValuesByIdFromState = ({ vacancies }: any, candidateId: any): any => {
    const candidateKeys = Object.keys(vacancies?.unsaved);

    let saved = vacancies?.saved[candidateId];
    if (candidateKeys.length == 0) return {...saved};

    let newValues: any = [];

    for (let key of Object.keys(vacancies?.unsaved[candidateId])) {
        let item = vacancies?.unsaved[candidateId][key];

        if (item.id) continue; 

        newValues.push({
            id: item.id,
            field_id: key,
            entity_id: candidateId,
            value: item.value
        });
    }

    let adjustedValues = saved?.values.map((value: any) => {
        if (!vacancies?.unsaved[candidateId]) return value;
        if (!vacancies?.unsaved[candidateId][value.field_id]) return value;

        return {
            ...value,
            value: vacancies.unsaved[candidateId][value.field_id]['value']
        }
    });

    return {
        ...saved,
        values: [...newValues, ...adjustedValues]
    };
};
export const getVacancyValuesById = createSelector(getVacancyValuesByIdFromState, (getVacancyValuesByIdFromState) => getVacancyValuesByIdFromState);

const getVacancyUnsavedChangesByIdFromState = ({ vacancies }: any, candidateId: any): any[] => vacancies?.unsaved[candidateId];
export const getVacancyUnsavedChangesById = createSelector(getVacancyUnsavedChangesByIdFromState, (getVacancyUnsavedChangesByIdFromState) => getVacancyUnsavedChangesByIdFromState);

const getVacancyEntityByIdFromState = ({ vacancies }: any, candidateId: any): any[] => vacancies?.saved[candidateId]?.entity[0];
export const getVacancyEntityById = createSelector(getVacancyEntityByIdFromState, (getVacancyEntityByIdFromState) => getVacancyEntityByIdFromState);

const getAllVacancyStatussesByIdFromState = ({ vacancies }: any, candidateId: any): any[] => vacancies?.saved[candidateId]?.status;
export const getAllVacancyStatussesById = createSelector(getAllVacancyStatussesByIdFromState, (getAllVacancyStatussesByIdFromState) => getAllVacancyStatussesByIdFromState);

const getVacancyDatasetFromState = ({ vacancies }: any): any[] => vacancies?.dataset;
export const getVacancyDataset = createSelector(getVacancyDatasetFromState, (getVacancyDatasetFromState) => getVacancyDatasetFromState);

const getNewVacancyIdFromState = ({ vacancies }: any): any[] => vacancies?.new;
export const getNewVacancyId = createSelector(getNewVacancyIdFromState, (getNewVacancyIdFromState) => getNewVacancyIdFromState);





const fetchRecords = ({ vacancies }: StoreState) => vacancies;
const byId = (_: StoreState, id) => id

export const getVacancyById = createSelector(
    fetchRecords,
    byId,
    ({ entities }, id) => entities?.[id]
);

export const getVacancyDatasetKeys = createSelector(
    fetchRecords,
    ({ datasets }) => datasets.ids
)

export const getVacancyByIdAsObject = createSelector(
    fetchRecords,
    ({ entities }) => entities
)

export const getVacancyCreateFlowId = createSelector(
    fetchRecords,
    ({ createFlowId }) => createFlowId
)

export const isVacancyFetching = createSelector(
    fetchRecords,
    ({ _isFetching }) => _isFetching
)

export const isVacancyFiltering = createSelector(
    fetchRecords,
    ({ _isFiltering }) => _isFiltering
)

export const isVacancyDatasetFetching = createSelector(
    fetchRecords,
    ({ datasets: { _isFetching } }) => _isFetching
)

export const getVacancyValuesByIdV2AsObject = createSelector(
    fetchRecords,
    ({ valuesByEntityIdByFieldId }) => valuesByEntityIdByFieldId
)

export const getVacancyValuesByIdV2 = createSelector(
    fetchRecords,
    (_, record_id) => record_id,
    ({ valuesByEntityIdByFieldId }, record_id) => valuesByEntityIdByFieldId?.[record_id]
)






export const getVacanciesByPageNumber = createSelector(
    fetchRecords,
    (_, page_number) => page_number,
    ({ pagination: { internal_pages }, entities}, page_number) => internal_pages?.[page_number]?.map(i => entities?.[i])
)

export const getVacancyPagination = createSelector(
    fetchRecords,
    ({ pagination }) => pagination
)

export const getVacancyStatistics = createSelector(
    fetchRecords,
    ({ statistics }) => statistics
)